import type { TraceItem } from './signals-content.types';

export const toCreatedAtIsoString = (
  value: string | Date | null | undefined,
): string => {
  if (value == null || value === '') {
    return '';
  }

  return new Date(value).toISOString();
};

export const getCreatedAtMs = (value: string | Date): number =>
  new Date(value).getTime();

export const getTraceItemCreatedAtMs = (trace: TraceItem): number =>
  getCreatedAtMs(trace.createdAt);

export const getTraceItemCreatedAtIsoString = (trace: TraceItem): string =>
  toCreatedAtIsoString(trace.createdAt);
